<template>
  <div
    class="crm-logo inline-flex items-baseline gap-1.5 select-none"
    :style="{ minHeight: `${height}px` }"
    role="img"
    aria-label="CRM EMPRESARIAL"
  >
    <span class="crm-logo__crm font-extrabold tracking-tight leading-none" :style="crmTextStyle">CRM</span>
    <span class="crm-logo__sub font-semibold uppercase leading-none tracking-tight" :style="subTextStyle"
      >Empresarial</span
    >
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useColors } from 'vuestic-ui'

const { getColor } = useColors()

const props = withDefaults(
  defineProps<{
    height?: number
    start?: string
    end?: string
    /** Si es false, el texto principal usa color sólido (p. ej. logo en 404) */
    gradient?: boolean
  }>(),
  {
    height: 18,
    start: 'primary',
    end: undefined,
    gradient: true,
  },
)

const colorsComputed = computed(() => ({
  start: getColor(props.start),
  end: getColor(props.end || props.start),
}))

const crmTextStyle = computed(() => {
  const size = `${Math.round(props.height * 1.15)}px`
  if (!props.gradient) {
    return {
      fontSize: size,
      color: colorsComputed.value.start,
    }
  }
  return {
    fontSize: size,
    background: `linear-gradient(90deg, ${colorsComputed.value.end}, ${colorsComputed.value.start})`,
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    color: 'transparent',
    WebkitTextFillColor: 'transparent',
  }
})

const subTextStyle = computed(() => ({
  fontSize: `${Math.round(props.height * 0.55)}px`,
  color: colorsComputed.value.start,
  opacity: 0.88,
}))
</script>
